import { NotificationManager } from "react-notifications";

import apiURL from "./apiURL";
import {checkExecutionStatus, createRequest} from "@/components/common/helpers/RequestHelpers";

const request = createRequest({
	urlPath: "/settings/advisors",
	// local: true,
});

const Types = {
	ADVISORS_UPDATE_MEMBER_LIST: "ADVISORS_UPDATE_MEMBER_LIST",
	ADVISORS_SET_INVITE_MODAL_STATUS: "ADVISORS_SET_INVITE_MODAL_STATUS",
	ADVISORS_ADD_MEMBER_STATUS: "ADVISORS_ADD_MEMBER_STATUS",
	ADVISORS_SET_CREATE_MODAL_STATUS: "ADVISORS_SET_CREATE_MODAL_STATUS",
	ADVISORS_NEW_STATUS: "ADVISORS_NEW_STATUS",
	ADVISORS_UPDATING_DETAILS: "ADVISORS_UPDATING_DETAILS",
	ADVISORS_UPDATE_SETTINGS: "ADVISORS_UPDATE_SETTINGS",
	ADVISORS_LOADED_LIST: "ADVISORS_LOADED_LIST",
	ADVISORS_UPDATE_CURRENT: "ADVISORS_UPDATE_CURRENT",
	ADVISORS_SCHEDULED_PAYROLLS_LOADED: "ADVISORS_SCHEDULED_PAYROLLS_LOADED",
	ADVISORS_PAYROLL_STATS_LOADED: "ADVISORS_PAYROLL_STATS_LOADED",
	ADVISORS_SCHEDULED_TASKS_LOADED: "ADVISORS_SCHEDULED_TASKS_LOADED",
	ADVISORS_SCHEDULED_TASK_DELETED: "ADVISORS_SCHEDULED_TASK_DELETED",
	ADVISORS_SCHEDULED_TASK_RUN_COMPLETE: "ADVISORS_SCHEDULED_TASK_RUN_COMPLETE",
	ADVISORS_SCHEDULED_TASK_PROCESSING: "ADVISORS_SCHEDULED_TASK_PROCESSING",
	ADVISORS_EVERROLL_SETTINGS: "ADVISORS_EVERROLL_SETTINGS",
	ADVISORS_EVERROLL_SETTINGS_MODAL: "ADVISORS_EVERROLL_SETTINGS_MODAL",
	ADVISORS_SAVING_EVERROLL_SETTINGS: "ADVISORS_SAVING_EVERROLL_SETTINGS",
	ADVISORS_GET_BILLING_EMAILS: "ADVISORS_GET_BILLING_EMAILS",
	ADVISORS_PAYMENT_MODAL: "ADVISORS_PAYMENT_MODAL",
};

const updateAdvisorMembersList = (response) => ({
	type: Types.ADVISORS_UPDATE_MEMBER_LIST,
	payload: response,
});

const gotEverRollSettings = (response) => ({
	type: Types.ADVISORS_EVERROLL_SETTINGS,
	payload: response,
});

const getAdvisorTeamMembers = (advisorId) => {
	return (dispatch, getState) => {
		fetch(`${apiURL}/settings/advisors/authorised-users/${advisorId}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.authorisedUsers) {
					dispatch(updateAdvisorMembersList(data.authorisedUsers));
				}
			});
	};
};

const removeTeamMember = ({ member, advisorId }) => {
	return (dispatch, getState) => {
		fetch(`${apiURL}/settings/advisors/remove-user`, {
			credentials: "include",
			method: "DELETE",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ userId: member.userId, advisor: advisorId }),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					dispatch(getAdvisorTeamMembers(advisorId));
					NotificationManager.success("User Removed From Advisor Team Successfully", "Advisor Team");
				}
			});
	};
};

const acceptInvite = (advisorId) => {
	return (dispatch, getState) => {
		request({
			method: "POST",
			path: "/invite/accept",
			body: {
				advisorId,
			},
		})
			.then(({ data }) => {
				window.location.reload();
			})
			.catch((e) => {
				console.error(e);
				NotificationManager.error("Error Accepting Invite", "Advisor Team");
			});
	};
};

const declineInvite = (advisorId) => {
	return (dispatch, getState) => {
		request({
			method: "POST",
			path: "/invite/decline",
			body: {
				advisorId,
			},
		})
			.then(({ data }) => {
				window.location.reload();
			})
			.catch((e) => {
				console.error(e);
				NotificationManager.error("Error Declining Invite", "Advisor Team");
			});
	};
};

const inviteAdvisorModal = (status) => ({
	type: Types.ADVISORS_SET_INVITE_MODAL_STATUS,
	status,
});

const addMemberStatus = (status) => ({
	type: Types.ADVISORS_ADD_MEMBER_STATUS,
	status,
});

const getUpcomingPayrolls = (data) => ({
	type: Types.ADVISORS_SCHEDULED_PAYROLLS_LOADED,
	data,
});

const payrollStatsLoaded = (data) => ({
	type: Types.ADVISORS_PAYROLL_STATS_LOADED,
	data,
});

const addTeamMember = ({ email, advisorId }) => {
	return (dispatch, getState) => {
		dispatch(addMemberStatus(true));
		fetch(`${apiURL}/settings/advisors/invite-user`, {
			credentials: "include",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ email, advisor: advisorId }),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success || !data.error) {
					dispatch(getAdvisorTeamMembers(advisorId));
					dispatch(inviteAdvisorModal(false));
					NotificationManager.success("User Added To Advisor Team Successfully", "Advisor Team");
				} else if (data.error) {
					NotificationManager.error(data.error, "Advisor Team");
				}
			})
			.catch((e) => NotificationManager.error("An Error Occurred!", "New Advisor Account"))
			.finally(() => {
				dispatch(addMemberStatus(false));
			});
	};
};

const createAdvisorModal = (status) => ({
	type: Types.ADVISORS_SET_CREATE_MODAL_STATUS,
	status,
});

const newAdvisorStatus = (status) => ({
	type: Types.ADVISORS_NEW_STATUS,
	status,
});

const scheduledTasks = (data) => ({
	type: Types.ADVISORS_SCHEDULED_TASKS_LOADED,
	data,
});

const processingScheduledTask = (id,status) => ({
	type: Types.ADVISORS_SCHEDULED_TASK_PROCESSING,
	id,
	status
});
const deletedScheduledTask = (id) => ({
	type: Types.ADVISORS_SCHEDULED_TASK_DELETED,
	id,
});
const runScheduledTaskComplete = (task) => ({
	type: Types.ADVISORS_SCHEDULED_TASK_RUN_COMPLETE,
	task,
});

const createAdvisor = (advisor) => {
	return (dispatch, getState) => {
		dispatch(newAdvisorStatus(true));

		const email = advisor.email;
		delete advisor.email;
		fetch(`${apiURL}/settings/advisors/create`, {
			credentials: "include",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ advisor, email }),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					dispatch(createAdvisorModal(false));
					NotificationManager.success("Successfully Created Advisor Account", "New Advisor Account");
				} else if (data.error) {
					NotificationManager.error(data.error, "New Advisor Account");
				}
			})
			.catch((e) => NotificationManager.error("An Error Occurred!", "New Advisor Account"))
			.finally(() => {
				dispatch(newAdvisorStatus(false));
			});
	};
};

const updatingAdvisorDetails = (status) => ({
	type: Types.ADVISORS_UPDATING_DETAILS,
	status,
});

const updateAdvisorDetails = ({ id, detailsToUpdate }) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(updatingAdvisorDetails(true));
		fetch(`${apiURL}/settings/advisors/update-details`, {
			credentials: "include",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ id, detailsToUpdate }),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					NotificationManager.success("Successfully Updated Details", "Update Advisor Details");
					// get latest details
					dispatch(getAdvisorSettings(id));
					if (state.payment.advisorModal) {
						// close the advisor modal if it was manually opened
						dispatch(showPricingModal(false, false));
					}
				} else if (data.error) {
					NotificationManager.error(data.error, "Update Advisor Details");
				}
			})
			.catch((e) => NotificationManager.error("An Error Occurred!", "Update Advisor Details"))
			.finally(() => {
				dispatch(updatingAdvisorDetails(false));
			});
	};
};

const setPartnerPlan = (plan) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(updateAdvisorDetails({ id: state.my?.profile?.advisorId, detailsToUpdate: { plan: plan.value } }));
	};
};

const updateAdvisorSettings = (payload) => ({
	type: Types.ADVISORS_UPDATE_SETTINGS,
	payload,
});

const getAdvisorSettings = (advisorId) => {
	return async (dispatch, getState) => {
		const state = getState();

		if (!advisorId) advisorId = state.my?.profile?.advisorId;
		if (!advisorId) return;

		await request({
			method: "GET",
			path: `/advisor-settings/${advisorId}`,
		})
			.then(({ data }) => {
				if (!data.settings) return;
				dispatch(updateAdvisorSettings(data.settings));
			})
			.catch((e) => {
				console.error(e);
			});
	};
};

const loadedAdvisorList = (payload) => ({
	type: Types.ADVISORS_LOADED_LIST,
	payload,
});

const getAdvisorList = () => {
	return async (dispatch, getState) => {
		await request({
			method: "GET",
			path: "/list",
		})
			.then(({ data }) => {
				dispatch(loadedAdvisorList(data.advisorList));
			})
			.catch((e) => {
				console.error(e);
			});
	};
};

const updateCurrentAdvisor = (payload) => ({
	type: Types.ADVISORS_UPDATE_CURRENT,
	payload,
});

const switchAdvisor = (advisorId) => {
	return (dispatch, getState) => {
		const state = getState();

		if (advisorId == state.my?.profile?.advisorId) {
			return;
		}

		fetch(apiURL + "/settings/advisors/set", {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ advisorId }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.switchedTo) {
					dispatch(getAdvisorSettings(advisorId));
					dispatch(updateCurrentAdvisor(advisorId));
				}
			});
	};
};

const getScheduledPayrolls = () => {
	return async (dispatch, getState) => {
		await request({
			method: "GET",
			path: "/upcoming-payrolls",
		})
			.then(({ data }) => {
				dispatch(getUpcomingPayrolls(data));
			})
			.catch((e) => {
				console.error(e);
				NotificationManager.error("Error Getting Upcoming Payrolls", "Advisor Payrolls");
			});
	};
};

const getPayrollStats = () => {
	return async (dispatch, getState) => {
		await request({
			method: "GET",
			path: "/payroll/stats",
		})
			.then(({ data }) => {
				dispatch(payrollStatsLoaded(data));
			})
			.catch((e) => {
				console.error(e);
				NotificationManager.error("Error Getting Upcoming Payrolls", "Advisor Payrolls");
			});
	};
};

const getScheduledTasks = () => {
	return async (dispatch, getState) => {
		await request({
			method: "GET",
			path: "/scheduled-tasks",
		})
			.then(({ data }) => {
				dispatch(scheduledTasks(data));
			})
			.catch((e) => {
				console.error(e);
				NotificationManager.error("Error Getting Scheduled Tasks", "Advisor Tasks");
			});
	};
};

const deleteScheduledTask = ({id}) => {
	return async (dispatch, getState) => {
		dispatch(processingScheduledTask(id,true));
		await request({
			method: "DELETE",
			path: `/scheduled-task/${id}`,
		})
			.then(({ data }) => {
				if (data.success) {
					dispatch(deletedScheduledTask(id));
				}
			})
			.catch((e) => {
				console.error(e);
				dispatch(processingScheduledTask(id,false));
				NotificationManager.error("Error Getting Scheduled Tasks", "Advisor Tasks");
			});
	};
};

const runScheduledTask = ({id}) => {
	return async (dispatch, getState) => {
		dispatch(processingScheduledTask(id,true));
		await request({
			method: "GET",
			path: `/scheduled-task/run/${id}`,
		})
			.then(({ data }) => {
				if (data.success && data.executionArn) {
					checkExecutionStatus(data.executionArn)
					.then(({ output }) => {
						if (output.status !== "Success") {
							NotificationManager.error("Automation Failed", "Automation Failed");
						} else if (output.status === "Processing") {
							NotificationManager.error("This Automation may take a while, check back later to see when it completes", "Automation Processing");
						} else {
							NotificationManager.error("Automation Ran Successfully", "Automation Success");
						}
						dispatch(
							runScheduledTaskComplete(output)
						);
					})
					.catch((err) => {
						console.log('output',err)
						console.error(err);
						dispatch(processingScheduledTask(id,false));
						NotificationManager.error("Automation Failed", "Automation Failed");
					});

				}
			})
			.catch((e) => {
				console.error(e);
				dispatch(processingScheduledTask(id,false));
						NotificationManager.error("Automation Failed", "Automation Failed");
			});
	};
};

const saveEverRollSettings = (settings) => {
	return async (dispatch, getState) => {
		const state = getState();
		const everRollSettingsModal = state?.advisors?.everRollSettingsModal;
		const { everRollRules } = state.advisors.everRollSettings || {};

		const { org, schedule } = everRollSettingsModal || {};
		const everRollRule = (everRollRules?.[org]?.find?.((r) => r?.entity === schedule) || {})?.id;

		dispatch(savingEverRollSettings(true));

		await request({
			method: "POST",
			path: `/update-automation-rules/${org}/${schedule}`,
			body: {
				id: everRollRule,
				rules: settings,
			},
		})
			.then(({ data }) => {
				dispatch(getEverRollSettings());
				dispatch(openEverRollModal(false));
				NotificationManager.success("EverRoll™ Settings Saved", "EverRoll™");
			})
			.catch((e) => {
				console.error(e);
				NotificationManager.error("Error Saving EverRoll™ Settings", "EverRoll™");
			});
		dispatch(savingEverRollSettings());
	};
};

const getEverRollSettings = () => {
	return async (dispatch, getState) => {
		await request({
			method: "GET",
			path: "/ever-roll",
		})
			.then(({ data }) => {
				dispatch(gotEverRollSettings(data));
			})
			.catch((e) => {
				console.error(e);
				NotificationManager.error("Error Getting EverRoll™ Settings", "EverRoll™");
			});
	};
};

const openEverRollModal = (status) => ({
	type: Types.ADVISORS_EVERROLL_SETTINGS_MODAL,
	status,
});

const savingEverRollSettings = (status) => ({
	type: Types.ADVISORS_SAVING_EVERROLL_SETTINGS,
	status,
});

const getBillingEmails = () => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/advisor/billingEmails`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => dispatch(loadedBillingEmails(data)))
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error getting billing emails", "Getting Billing Emails");
			});
	};
};

const loadedBillingEmails = (payload) => ({
	type: Types.ADVISORS_GET_BILLING_EMAILS,
	payload,
});

const showPricingModal = (status, isNew) => ({
	type: Types.ADVISORS_PAYMENT_MODAL,
	status,
	isNew,
});

const Actions = {
	getAdvisorTeamMembers,
	removeTeamMember,
	addTeamMember,
	inviteAdvisorModal,
	createAdvisorModal,
	createAdvisor,
	updateAdvisorDetails,
	getAdvisorSettings,
	getAdvisorList,
	switchAdvisor,
	setPartnerPlan,
	getScheduledPayrolls,
	getScheduledTasks,
	getEverRollSettings,
	openEverRollModal,
	saveEverRollSettings,
	acceptInvite,
	declineInvite,
	getBillingEmails,
	showPricingModal,
	runScheduledTask,
	deleteScheduledTask,
	getPayrollStats
};

export { Types, Actions };
